import React, { useContext } from "react";

import MapBase, { MapContext } from "./MapBase";
import colors from "config/colors";

const TrackingMap = ({
  mapConfig,
  doors,
  gateways,
  carts,
  employees,
  showLabels,
  connecting,
  showHeatmap,
  cartsHeatmap,
}) => {
  return (
    <MapBase
      mapConfig={mapConfig}
      doors={doors}
      gateways={gateways}
      connecting={connecting}
      width="70%"
    >
      {/* draw carts */}
      {!showHeatmap ? (
        <Carts carts={carts} withLabels={showLabels} />
      ) : null}
      {/* draw cars heatmap */}
      {showHeatmap ? (
        <HeatMap data={cartsHeatmap} withLabels={showLabels} />
      ) : null}
      {/* draw forklifts */}
      {/* <Forklifts forklifts={forklifts} mapConfig={mapConfig} withLabels={showLabels} /> */}
      {/* draw employees */}
      <Employees employees={employees} withLabels={showLabels} />
    </MapBase>
  );
};

const Carts = React.memo(({ carts, mapConfig, withLabels }) => {
  const { cart_color, cart_w, colors, xScaleFactor, yScaleFactor } =
    useContext(MapContext);
  const magicNr = 0.86602540378; // sqrt(1/4)

  const color = colors[cart_color] || cart_color || colors.black;
  const cartWidth = cart_w || 0.3;
  const cartHeight = cartWidth * magicNr;
  const fontSize = (cartWidth / 2).toFixed(2);

  return (
    <g id="carts">
      {carts.map((c) => (
        <g key={c.name}>
          <polygon
            points={`
                  ${c.y * xScaleFactor},${c.x * yScaleFactor - cartHeight / 2} 
                  ${c.y * xScaleFactor - cartWidth / 2},${c.x * yScaleFactor + cartHeight / 2
              }
                  ${c.y * xScaleFactor + cartWidth / 2},${c.x * yScaleFactor + cartHeight / 2
              }
                `}
            fill={color}
          />
          {withLabels && (
            <text
              x={c.y * xScaleFactor}
              y={c.x * yScaleFactor}
              fill={color.black}
              fontSize={fontSize}
            >
              {c.name}
            </text>
          )}
        </g>
      ))}
    </g>
  );
});

const HeatMap = ({ data, withLabels }) => {
  const { xScaleFactor, yScaleFactor, door_height } = useContext(MapContext);
  const fontSize = (door_height / 8).toFixed(2);

  const colorForValue = (value) => {
    var h = (1.0 - value) * 240;
    return `hsl(${h}, 100%, 50%, ${value > 0.3 ? parseInt(value * 100, 10) : 30
      }%)`;
  };

  if (!data) {
    return;
  }

  const { hits, max, total: totalHits, loading } = data;
  const cellSize = 1 * xScaleFactor;

  return (
    <g id="carts-heatmap">
      {Object.values(hits)
        .sort((a, b) => a.hits - b.hits)
        .map((c, i) => {
          const X = c.x * xScaleFactor;
          const Y = c.y * yScaleFactor;

          return (
            <g key={c.key}>
              <circle
                key={c.key}
                cx={X}
                cy={Y}
                r={cellSize / 2}
                fill={colorForValue(c.hits / max)}
              />
              {withLabels && i === 0 && (
                <text
                  x={X}
                  y={Y}
                  fill={colors.black}
                  fontSize={fontSize}
                  fontWeight={600}
                >
                  {loading ?
                    "Loading Heatmap..."
                    : `${c.dcX.toFixed(2)}, ${c.dcY.toFixed(2)}: ${Math.round(
                      (c.hits / totalHits) * 100
                    )}%`
                  }
                </text>
              )}
            </g>
          );
        })}
    </g>
  );
};

// const Forklifts = React.memo(({ forklifts }) => {
//   const { foklift_color, forklift_w, colors, xScaleFactor, yScaleFactor } = useContext(MapContext);

//   const color = colors[foklift_color] || foklift_color || colors.black;
//   const forkliftWidth = forklift_w || 0.5;
//   // const fontSize = (forkliftWidth / 2).toFixed(2);

//   return (
//     <g id="forklifts">
//       {
//         forklifts.map(f => (
//           <rect
//             x={f.y * xScaleFactor}
//             y={f.x * yScaleFactor}
//             width={forkliftWidth}
//             height={forkliftWidth}
//             fill={color}
//           />
//         ))
//       }
//     </g>
//   );
// });

const Employees = React.memo(({ employees, withLabels }) => {
  const { person_color, person_w, colors, xScaleFactor, yScaleFactor } =
    useContext(MapContext);

  const color = colors[person_color] || person_color || colors.black;
  const personWidth = person_w || 0.5;
  const fontSize = personWidth * 2;

  return (
    <g id="employees">
      {employees.map((e) => (
        <g key={e.name}>
          <circle
            key={e.name}
            cx={e.y * xScaleFactor}
            cy={e.x * yScaleFactor}
            r={personWidth}
            fill={color}
          />
          {withLabels && (
            <text
              x={e.y * xScaleFactor}
              y={e.x * yScaleFactor}
              fill={colors.black}
              fontSize={fontSize}
            >
              {e.name}
            </text>
          )}
        </g>
      ))}
    </g>
  );
});

export default TrackingMap;
